import React, { FC } from 'react';
import { Grid2, styled } from '@mui/material';
import { Header, SIDEBAR_DESKTOP } from 'dashboard409a/components';
import { useAttioValuationContext } from 'dashboard409a/context/AttioValuationContext';
import { ITheme } from 'theme/types';
import { IMainContainer } from './types';

const RootGrid = styled(Grid2)(({ theme }) => ({
  width: '100%',
  minHeight: '100%',
  zIndex: 100,
  backgroundColor: (theme as unknown as ITheme).palette.white,

  [theme.breakpoints.up('md')]: {
    paddingLeft: SIDEBAR_DESKTOP.width,
  },
}));

const MainGrid = styled(Grid2)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
}));

const MainContainer: FC<IMainContainer> = props => {
  const { children, currentCompany, isLoading, navigationItems } = props;
  const { currentAttioCompanyName } = useAttioValuationContext();

  const pageTitle = currentAttioCompanyName || currentCompany?.name || '';

  return (
    <RootGrid direction="column" wrap="nowrap">
      <Header isLoading={isLoading} navigationItems={navigationItems} pageTitle={pageTitle} />

      <MainGrid container direction="row" justifyContent="space-between" alignItems="center">
        {children}
      </MainGrid>
    </RootGrid>
  );
};

export default MainContainer;
